import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ConfirmDialog from "../../../components/popups/ConfirmDialog";
import Langs from "../../../app/lang/langs";
import { showErrorToast, checkPermission } from "../../../app/utils/helpers";
import { config } from "../../../app/utils/config";
import { deletePlanning, getPlanning } from "../planningSlice";
import moment from "moment";

export function MobileDeleteModal({ show, onHide }) {
  const dispatch = useDispatch();

  const collabs = useSelector((state) => state.collabs.list);
  const selectedView = useSelector((state) => state.planning.selectedView);
  const selectedDate = useSelector((state) => state.planning.selectedDate);
  const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds);

  function isManager(teamId) {
    return checkPermission(config.scopes.shifts, config.permissionTypes.edit, teamId);
  }

  function handleDeletePlanning() {
    let range = "month";
    if (selectedView == "WEEKLY") {
      range = "week";
    }
    let from = moment(selectedDate).startOf(range).format("x");
    let to = moment(selectedDate).endOf(range).format("x");

    if (from && to) {
      let params = {
        teamIds: selectedTeamsIds.filter((id) => isManager(id)),
        from: from,
        to: to,
      };
      dispatch(deletePlanning(params)).then((response) => {
        if (response["payload"]["responseData"]["status"] == 1) {
          loadPlanning();
        }
        if (response["payload"]["responseData"]["status"] == 4) {
          showErrorToast(response["payload"]["responseData"]["message"]);
        }
        if (response["payload"]["responseError"]) {
          showErrorToast();
        }
      });
    }
    onHide();
  }

  function loadPlanning() {
    if (selectedTeamsIds && selectedTeamsIds.length && collabs.length) {
      let selectedCollabsIds = collabs.reduce((array, current) => {
        array.push(current.id);
        return array;
      }, []);
      dispatch(getPlanning({ selectedTeamsIds, selectedCollabsIds }));
    }
  }

  return (
    <ConfirmDialog
      open={!!show}
      danger
      title={<Langs str="Delete planning" />}
      message={<Langs str="DELETE_PLANNING_VALIDATION_MSG" />}
      onConfirm={handleDeletePlanning}
      onCancel={onHide}
    />
  );
}
